import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/home/Home';
import Board from './pages/inquiry/Board';
import Inquiry from './pages/inquiry/Inquiry';
import InquiryDetail from './pages/inquiry/InquiryDetail';
import Instructor from './pages/instructor/Instructor';
import Login from './pages/authorizaiton/Login';
import Register from './pages/authorizaiton/Register';
import Cart from './pages/cart/Cart';
import Profile from './pages/profile/Profile';
import Product from './pages/product/Product';
import CheckOut from './pages/pay/CheckOut';
import Process from './components/pay/Process';
import Success from './pages/pay/Success';
import Refund from './pages/pay/Refund';

function App() {
  return (
    <div className="App">
     <BrowserRouter>
        <Routes>
            <Route path='/' element={<Home />}/>
            <Route path='/instructor' element={<Instructor />}/>
            <Route path='/product/:id' element={<Product />}/>
            <Route path='/board' element={<Board />} />
            <Route path='/inquiry' element={<Inquiry />}/> 
            <Route path='/inquiry/detail' element={<InquiryDetail />}/>
            <Route path='/cart' element={<Cart />}/>
            <Route path='/profile' element={<Profile />}/>
            <Route path="/pay/:id" element={<CheckOut/>} />
            <Route path="/process" element={<Process />} />
            <Route path='/success' element={<Success />}/>
            <Route path='/login' element={<Login/>}/>
            <Route path='/register' element={<Register />}/>
            <Route path='/policy-refund' element={<Refund />}/>
            <Route path="/fail" element={<h1>결제가 실패했습니다.</h1>} />
        </Routes>
     </BrowserRouter>
    </div>
  );
}

export default App;
